import * as types from '../../../actions/actiontypes';

import {documentTypes} from '../../../util/uiconstants';
import {getFileNameAndExtension} from '@ey/utils';
import initialState from '../../initialstate';

export default function addclientRequestDocumentsReducer(state = initialState.addclientRequestDocuments, action) {
	switch (action.type) {
		case 'ASSOCIATE_CLIENTREQUEST_DOCUMENT': {
			if (action?.meta?.upchunk?.payload?.documentName) {
				let newState = _.cloneDeep(state);
				const [documentName, fileExt] = getFileNameAndExtension(action.meta.upchunk.payload.documentName);
				let documentItem = {
					id: action.meta.upchunk.payload.documentId,
					documentID: action.meta.upchunk.payload.documentId,
					documentName: documentName || 'Document',
					fileExt: fileExt || 'docx',
					lastModifiedFullName: action.meta.upchunk.payload.userName,
					modifiedDate: action.meta.upchunk.payload.createDate,
					clientSignOffJSON: null,
					documentTypeId: documentTypes.CRASH
				};

				let updatedState = newState.slice();
				// remove if file exist in the collection
				updatedState = updatedState.filter((x) => x.id !== action.meta.upchunk.payload.documentId);
				updatedState.splice(0, 0, documentItem);

				return updatedState;
			}
			return state;
		}
		case 'REMOVE_CLIENTREQUEST_DOCUMENT': {
			return filterOutByDocumentId(action?.documentId, state);
		}
		case 'CLEAR_ALL_CLIENTREQUEST_DOCUMENTS': {
			// Put back to default state
			return initialState.addclientRequestDocuments;
		}
		case types.SEND_CUSTOM_CLIENT_REQUEST: {
			// Put back to default state
			// Fixed For Defect -> 1093482
			return action?.error ? state : initialState.addclientRequestDocuments;
		}
		case types.COPY_TASK_DOCUMENTS_TO_ADD_DOCUMENTS: {
			return action?.data;
		}
		case types.RELATE_DOCUMENT_TO_EXISTING_REQUEST: {
			const updatedState = [..._.cloneDeep(state), action.data];
			return updatedState;
		}
		case types.UNRELATE_DOCUMENT_TO_EXISTING_REQUEST: {
			const updatedState = _.cloneDeep(state).filter((x) => x.id !== action.data);
			return updatedState;
		}
		case types.MARK_AS_DELETED_DOCUMENT: {
			return filterOutByDocumentId(action?.documentId, state);
		}
		case types.CREATE_ANALYTIC_DOCUMENT: {
			const analyticDocument = {
				id: action.response.id,
				documentId: action.response.id,
				documentName: action.response.name,
				documentTypeId: action.response.documentTypeID,
				engagementId: action.response.engagementId,
				fileExt: action.response.fileExtension,
				lastModifiedFullName: action.meta.lastModifiedBy,
				modifiedDate: action.response.modifiedDate
			};

			const documentInRedux = state.find(
				(document) =>
					document.documentName === action.response.name && document.documentTypeId === action.response.documentTypeID
			);

			if (documentInRedux) {
				return [{...documentInRedux, ...analyticDocument}];
			}

			return state;
		}
		default:
			return state;
	}
}

const filterOutByDocumentId = (documentId, collection) => {
	return collection.filter((element) => element.id !== documentId);
};
